<template>
  <div class="joe">
    <draggable v-model="localOptions" handle=".joe-row__drag" @end="emit">
      <div v-for="(option, index) in localOptions" :key="option.id || index" class="joe-row">
        <span class="joe-row__drag"><feather-icon icon="MenuIcon" size="14"/></span>

        <b-form-input class="joe-row__label" :value="option.label"
                      :placeholder="msg('optionlabel')"
                      @input="patch(index, {label: $event})"/>

        <b-form-input class="joe-row__desc" :value="option.description"
                      :placeholder="msg('optiondescription')"
                      @input="patch(index, {description: $event})"/>

        <!-- link an upsell product -->
        <v-select
            append-to-body
            class="joe-row__product"
            :value="option.guestFeatureId"
            :options="features"
            label="name"
            :reduce="feature => feature.id"
            :clearable="true"
            :placeholder="msg('optionlinkproduct')"
            :dir="isRTL ? 'rtl' : 'ltr'"
            @input="patch(index, {guestFeatureId: $event})"
        />

        <b-form-input v-if="option.guestFeatureId" class="joe-row__amount" type="number" min="1"
                      :value="option.amount || 1" v-b-tooltip.hover :title="msg('optionamount')"
                      @input="patch(index, {amount: Number($event) || 1})"/>

        <b-form-checkbox class="joe-row__free" :checked="option.freeText === true"
                         v-b-tooltip.hover :title="msg('optionfreetext')"
                         @change="patch(index, {freeText: $event})">
          <feather-icon icon="Edit3Icon" size="13"/>
        </b-form-checkbox>

        <b-button variant="flat-danger" size="sm" class="btn-icon" @click="remove(index)">
          <feather-icon icon="XIcon" size="14"/>
        </b-button>

        <small v-if="warningFor(option)" class="joe-row__warn">
          <feather-icon icon="AlertTriangleIcon" size="12"/> {{ warningFor(option) }}
        </small>
      </div>
    </draggable>

    <b-button variant="outline-primary" size="sm" class="mt-50" @click="add">
      <feather-icon icon="PlusIcon" size="14" class="mr-25"/>{{ msg('addoption') }}
    </b-button>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import draggable from 'vuedraggable'

/** Preset answers of a choice question, each optionally linked to an upsell. */
export default {
  name: 'journeyOptionEditor',
  components: {draggable},
  props: {
    value: {type: Array, default: () => []},
    /** guest features available for linking */
    features: {type: Array, default: () => []},
  },
  data() {
    return {localOptions: []}
  },
  computed: {
    ...mapGetters('translator', ['msg']),
    ...mapGetters('appConfig', ['isRTL']),
  },
  created() {
    this.localOptions = [...(this.value || [])];
  },
  watch: {
    value(list) {
      this.localOptions = [...(list || [])];
    },
  },
  methods: {
    add() {
      const index = this.localOptions.length + 1;
      this.localOptions.push({
        value: 'option_' + index + '_' + Date.now().toString(36),
        label: '',
        amount: 1,
      });
      this.emit();
    },
    remove(index) {
      this.localOptions.splice(index, 1);
      this.emit();
    },
    patch(index, patch) {
      this.$set(this.localOptions, index, {...this.localOptions[index], ...patch});
      this.emit();
    },
    warningFor(option) {
      if (!option.guestFeatureId) return null;
      const feature = this.features.find(item => item.id === option.guestFeatureId);
      if (!feature) return this.msg('featuremissing');
      if (feature.autoApprove !== true) return this.msg('featurenotinstantpay');
      return null;
    },
    emit() {
      this.$emit('input', this.localOptions);
    },
  }
}
</script>

<style lang="scss" scoped>
.joe-row {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  padding: 6px;
  border-radius: 9px;
  border: 1px solid rgba(34, 41, 47, .09);
  margin-bottom: 6px;
  background: #fff;

  &__drag {
    cursor: grab;
    color: #b9b9c3;
  }

  &__label {
    flex: 1 1 130px;
    min-width: 110px;
  }

  &__desc {
    flex: 1 1 130px;
    min-width: 110px;
  }

  &__product {
    flex: 1 1 170px;
    min-width: 150px;
  }

  &__amount {
    width: 68px;
  }

  &__free {
    margin: 0 2px;
  }

  &__warn {
    flex-basis: 100%;
    color: #ff9f43;
  }
}

.dark-layout .joe-row {
  background: #283046;
  border-color: rgba(255, 255, 255, .09);
}
</style>
